import { useGetTerminal } from '@dhl/mdp-api'
import { convertToTerminal } from '~/modules/terminals/model'

export const useTerminal = (id: string | undefined) => {
  const { data: terminalDto, isFetching } = useGetTerminal(id || '', { query: { enabled: !!id } })
  const terminal = terminalDto ? convertToTerminal(terminalDto) : undefined
  return { terminal, isLoading: isFetching }
}
